import supabase from '../lib/supabase';

/**
 * News service — reads curated ownership/money news items that power the
 * "In the News" strip on the homepage. Rows are managed from the admin panel.
 */
export const newsService = {
  /** Latest published articles, newest first. */
  async getLatestNews(limit = 12) {
    const { data, error } = await supabase
      .from('news_articles')
      .select('id, title, summary, url, source, image_url, category, related_subject, published_at')
      .eq('is_published', true)
      .order('published_at', { ascending: false })
      .limit(limit);

    if (error) {
      console.error('❌ newsService.getLatestNews:', error.message);
      return [];
    }
    return data || [];
  },
};

export default newsService;
